import React, { Component } from 'react';
import {MainLayout} from 'components/layouts';
import {ProductList} from 'components/fair/fair-product';
import {Link} from 'react-router-dom';

export default class FairProducts extends Component {

  render() {
    return (
      <MainLayout>
        <div>
          <div className='mb15'>
            <Link className='btn-back' to={`/fair/${this.props.match.params.id}`}><i className='fa fa-chevron-left' />Quay về trang chi tiết hội chợ</Link>
          </div>
          <div className='wrap-heading'>
            <h1>Các Sản phẩm tham gia hội chợ</h1>
            <div className='list-actions'>
              <Link to={`/fair/${this.props.match.params.id}/products/reject`} className='dark'>Sản phẩm bị từ chối</Link>
              <Link to={`/fair/${this.props.match.params.id}/products/add`}>Tạo mới sản phẩm</Link>
            </div>
          </div>
          <ProductList match={this.props.match}/>
        </div>
      </MainLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/fair/fair-products/FairProducts.jsx